var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('p',{staticClass:"khb h4"},[_vm._v(_vm._s(_vm.$t('invoice.text')))]),(_vm.invoiceData)?_c('div',[_c('List',{attrs:{"dataList":_vm.invoiceData,"more":{
          sub: [
          {name: 'manage.payment', icon:'bx bx-money', link: 'manage-invoice-payment', column: 'id', show: {column: 'status_id', value: 2}},
          {name: 'manage.payment', icon:'bx bx-money', link: 'manage-invoice-payment', column: 'id', show: {column: 'status_id', value: 3}},
          {name: 'invoice.print', icon:'bx bx-printer', link: 'manage-invoice-print', column: 'id'},
          {name: 'invoice.void', icon:'fas fa-times', link: 'manage-invoice-void', column: 'id', show: {column: 'is_void', value: 0}} ]
        },"filter":{
          search: ['mg_invoices.code', 'customers.name', 'customers.name_en'],
          dropdown: [{
            title: 'property.status',
            field: 'mg_invoices.status_id',
            data: this.invoiceStatusData,
            width: 2
          }]
        },"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'code', type: 'fast-view'}, {name: 'invoice_date', type: 'date'}, {name: 'expired_date', type: 'date'}, {name: 'status', color: true}, {name:'total', type:'currency'}, {name:'amount_to_pay', type:'currency'}],"fields":[ 
          ("code: " + (_vm.$t('payment.code'))), 
          ("invoice_date: " + (_vm.$t('invoice.date'))), 
          ("expired_date: " + (_vm.$t('booking.expired'))), 
          ("status: " + (_vm.$t('invoice.status'))), 
          ("total: " + (_vm.$t('invoice.total'))),
          ("penalty_amount: " + (_vm.$t('manage.penalty-setting.penalty-amount'))),
          ("receive_amount: " + (_vm.$t('manage.receive-amount'))),
          ("customer_name_en: " + (_vm.$t('customer.text'))),
          ("service_for: " + ('ចេញអោយ'))
          ]},on:{"more":_vm.moreClick}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }